// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"ReferralProgram_loadingWrapper__3IQHz","referralIframe":"ReferralProgram_referralIframe__213CB"};